<template>
  <div
    class="rfp-rr-avg-cus-ratings-007-or rr-avg-customer-rating float-left"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
  >
    <div class="rfp-rr-avg-cus-ratings-008-or rr-avg-customer-rating-inner">
      <h3 class="rfp-rr-avg-cus-ratings-009-or rr-sub-title white">{{ headerTitle }}</h3>
      <div
        class="rfp-rr-avg-cus-ratings-010-or rr-avg-rating-content clear float-left mobile-width-assign"
      >
        <span
          class="rfp-rr-avg-cus-ratings-011-or rr-label float-left bold mobile-average-customer"
          >{{ labelOverall }}</span
        >
        <div class="rfp-rr-avg-cus-ratings-012-or review-stars">
          <vue-star-rating
            :increment="starRatingIncrementValue"
            :max-rating="starRatingMaxRatingValue"
            :inactive-color="starRatingInactiveColor"
            :active-color="starRatingActiveColor"
            :star-size="starRatingStarSize"
            :rating="overallRating"
            :read-only="true"
            :show-rating="false"
          >
          </vue-star-rating>
        </div>
        <span
          class="rfp-rr-avg-cus-ratings-013-or rr-label-info float-right bold average-cus-ratings-mobile"
          >{{ overallRating }}</span
        >
      </div>
      <div
        v-if="showQualityOfProduct"
        class="rfp-rr-avg-cus-ratings-014-or rr-avg-rating-content clear float-left mobile-width-assign"
      >
        <span
          class="rfp-rr-avg-cus-ratings-015-or rr-label float-left bold mobile-average-customer-and-width"
          >{{ qualityOfProduct }}</span
        >
        <span class="rfp-rr-avg-cus-ratings-016-or rr-rating-bar-outer"
          ><span class="rr-rating-bar-inner" :style="{ width: ratingBar.Average }"></span
        ></span>
        <span class="rfp-rr-avg-cus-ratings-017-or rr-label-info float-right bold">{{
          ratingBar.count
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueStarRating from 'vue-star-rating';

export default {
  name: 'rfp-ratings-average-customer-ratings',
  components: {
    VueStarRating,
  },
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    labelOverall: {
      type: String,
      required: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    qualityOfProduct: {
      type: String,
      required: true,
    },
    ratingBar: {
      type: Object,
      required: true,
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    showQualityOfProduct: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      overallRating: this.rating,
    };
  },
};
</script>
